import { FlagComponent } from "@type/index";

export enum FLAG_TYPE {
  PRICE = "price",
  PRODUCT = "product"
}

enum FLAG_COLOR_CONFIG {
  RED = "promotional",
  GREY = "placeholder",
  BLACK = "standard"
}

export type flagColorType =
  | "promotional"
  | "placeholder"
  | "primary-dark"
  | "secondary"
  | undefined;

type flagConfigObj = {
  flag_color: flagColorType;
};

type newObjType = {
  price_flag?: [
    {
      name: string;
      color: flagColorType;
    }
  ];
  product_flag?: {
    name: string;
    color: flagColorType;
  };
};

/**
 * refer to "Wave 1.5 Product_Price flags" excel
 */
const priceFlagConfig: { [key: string]: flagConfigObj } = {
  specialPrice: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  multibuy: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  appmemberLimited: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  onlineLimited: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  limitedOffer: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  newPrice: {
    flag_color: FLAG_COLOR_CONFIG.GREY
  },
  discount: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  colorSizeLimitedPrice: {
    flag_color: FLAG_COLOR_CONFIG.RED
  },
  bundledOffer: {
    flag_color: FLAG_COLOR_CONFIG.RED
  }
};

export const handleFlagsSort = (
  priceFlag: Array<FlagComponent>,
  productFlag: Array<FlagComponent>,
  t: any,
  promotionText?: string
) => {
  const newPriceFlag = JSON.parse(JSON.stringify(priceFlag));
  const newProductFlag = JSON.parse(JSON.stringify(productFlag));
  const obj: newObjType = {
    price_flag: undefined,
    product_flag: undefined
  };
  if (newPriceFlag.length > 0) {
    obj.price_flag = newPriceFlag.map((p: FlagComponent) => {
      const name =
        p.nameWording && p.nameWording?.flagWithTime
          ? t(p.nameWording.flagWithTime, {
              date: p.nameWording.substitutions?.date,
              month: p.nameWording.substitutions?.month,
              flagName: p.nameWording.substitutions?.flagName
            })
          : p.detail;
      const priceData = {
        name: promotionText && p.code === "specialPrice" ? promotionText : name,
        color: priceFlagConfig[p.code]?.flag_color || FLAG_COLOR_CONFIG.RED
      };
      return priceData;
    });
  }
  if (newProductFlag.length > 0) {
    newProductFlag.reduce((flags: Array<FlagComponent>, f: FlagComponent) => {
      if (f.code === "comingSoon") {
        flags.unshift(f);
      } else {
        flags.push(f);
      }
      return flags;
    }, []);
    obj.product_flag = {
      name: newProductFlag
        .map((p: FlagComponent) => {
          const name =
            p.nameWording && p.nameWording?.flagWithTime
              ? t(p.nameWording.flagWithTime, {
                  date: p.nameWording.substitutions?.date,
                  month: p.nameWording.substitutions?.month,
                  flagName: p.nameWording.substitutions?.flagName
                })
              : p.detail;
          return name;
        })
        .toString()
        .split(",")
        .join(", "),
      color: "placeholder"
    };
  }
  return obj;
};
